import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  buildCanonicalUrl,
  getPageMeta,
  isIndexablePath,
} from '@/lib/seo';
import { removeCanonicalLink, setCanonicalLink, setJsonLd, setMeta } from '@/lib/seoDom';
import { buildStructuredData } from '@/lib/structuredData';

const PAGE_SCHEMA_ID = 'nexus-page-schema';

/**
 * Mantém título, description, canônico, Open Graph e JSON-LD sincronizados
 * com a rota atual. Cada página aponta o canônico para si mesma (nunca para a
 * home) e rotas internas/páginas utilitárias recebem noindex.
 */
export default function SeoCanonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = getPageMeta(pathname);
    const canonicalUrl = buildCanonicalUrl(pathname);

    document.title = meta.title;

    setMeta('name', 'description', meta.description);
    setMeta('property', 'og:title', meta.title);
    setMeta('property', 'og:description', meta.description);
    setMeta('property', 'og:site_name', SITE_NAME);
    setMeta('property', 'og:locale', 'pt_BR');
    setMeta('property', 'og:type', 'website');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', meta.title);
    setMeta('name', 'twitter:description', meta.description);

    if (isIndexablePath(pathname)) {
      setCanonicalLink(canonicalUrl);
      setMeta('property', 'og:url', canonicalUrl);
      setMeta('name', 'robots', 'index, follow');
      setMeta('property', 'og:image', DEFAULT_OG_IMAGE);
      setMeta('name', 'twitter:image', DEFAULT_OG_IMAGE);
      setJsonLd(PAGE_SCHEMA_ID, buildStructuredData(pathname));
    } else {
      removeCanonicalLink();
      setMeta('name', 'robots', 'noindex, nofollow');
      setJsonLd(PAGE_SCHEMA_ID, null);
    }
  }, [pathname]);

  return null;
}